import { ITaxGroup } from "../models";
import { CreateAuthHeader, AuthenticatedFetch } from "../utils/Helpers";
import { IService } from "./ICommonServices";

export class TaxGroupService implements IService<ITaxGroup>
{
    private controller = "api/taxgroups";

    public async GetAll(): Promise<ITaxGroup[]> 
    {
        let result: ITaxGroup[] = [];

        const requestOptions = {
            method: 'GET',
            headers: CreateAuthHeader()
        };
        
        const response = await AuthenticatedFetch(this.controller, requestOptions);
        if(!response.ok)
        {
            return result;
        }

        return await response.json() as ITaxGroup[];
    }

    public async Get(id: number): Promise<ITaxGroup> 
    {
        const requestOptions = {
            method: 'GET',
            headers: CreateAuthHeader()
        };
        
        const response = await AuthenticatedFetch(`${this.controller}/${id}`, requestOptions);
        if(!response.ok)
        {
            throw new Error("Bank not found");
        }

        return await response.json() as ITaxGroup;
    }

    public async Create(item: ITaxGroup) : Promise<string>
    {
        const requestOptions = {
            method: 'POST',
            headers: CreateAuthHeader(),
            body: JSON.stringify(item)
        };
    
        const response = await AuthenticatedFetch(this.controller, requestOptions);

        return await response.text();
    }

    public async Update(item: ITaxGroup) : Promise<string>
    {
        const requestOptions = {
            method: 'PATCH',
            headers: CreateAuthHeader(),
            body: JSON.stringify(item)
        };
    
        const response = await AuthenticatedFetch(this.controller, requestOptions);

        return await response.text();
    }

    public async Delete(id: number) : Promise<string>
    {
        const requestOptions = {
            method: 'DELETE',
            headers: CreateAuthHeader()
        };
    
        const response = await AuthenticatedFetch(`${this.controller}/${id}`, requestOptions);

        return await response.text();
    }   
}
